// Vista subcategoprías
import React from 'react';
import API from '../../configAPI';
import PulseLoader from 'react-spinners/PulseLoader';
import {Link} from 'react-router-dom';
import CONFIG from '../../config';
import BannerLarge from '../partials/BannerLarge';
class SubcatesCategory extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            categ_slug : this.props.match.params.category,
            category : {
                sub_categories: [],
                item : {}
            },
            loading : true,
        }
    }
    componentDidMount(){
        API.PRODUCTS(`sub-categories/category/${this.state.categ_slug}`)
        .then(resp =>{
            this.setState({
                category : resp.data,
                loading : false
            });
            console.log(resp);
        })
        .catch(err =>{
            console.log(err);
        });
    }

    render(){
        return(
            <div className="container-fluid mt-2 mb-2">
                {/* <BannerLarge 
                    url="https://dossierdearquitectura.com/"
                    image="https://dossierdearquitectura.com/banner/da728x160.jpg"
                    title="Visite Dossier de Arquitectura"
                /> */}
                <div className="col-12">
                    <PulseLoader
                        css={CONFIG.spinner_css}
                        size={CONFIG.spinner_size}
                        margin={CONFIG.spinner_margin}
                        color={CONFIG.spinner_color}
                        loading={this.state.loading}
                    />
                    <div className="row d-flex flex-wrap mt-2">
                        {/* <div className="col-xs-12 col-md-3 mt-1 mb-1">
                            <div className="list-group">
                                <li className="list-group-item secondary bg-black">{this.state.category.name}</li>
                                {this.state.category.sub_categories.map((subcate,index) =>(
                                    <Link to={`/productos/${this.state.category.item.slug}/${this.state.category.slug}/${subcate.slug}/`} key={index} className="list-group-item d-flex justify-content-between align-items-center list-group-item-action item-menu">
                                        {subcate.name}
                                    </Link>
                                ))}
                            </div>
                        </div> */}
                        <div className="col-xs-12 col-md-12 mt-1 mb-1">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item" aria-current="page">
                                        <Link to={`/productos/${this.state.category.item.slug}`} >{this.state.category.item.name}</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        {this.state.category.name}
                                    </li>
                                </ol>
                            </nav>
                            <div className="row d-flex flex-wrap mt-1">
                            {this.state.category.sub_categories.map((subcate,index) =>(
                                <article className="col-6 col-sm-6 col-md-3 mt-2" key={index}>
                                    <div className="rubro">
                                        <Link to={`/productos/${this.state.category.item.slug}/${this.state.category.slug}/${subcate.slug}/`}>
                                                <img src={subcate.url_image} alt={subcate.name}/>
                                                <h3>{subcate.name}</h3>
                                        </Link>
                                    </div>
                                </article>
                            ))}
                            </div>
                        </div>
                    </div>
                </div>

                <BannerLarge 
                    url="https://dossierdearquitectura.com/"
                    image="https://dossierdearquitectura.com/banner/da728x160.jpg"
                    title="Visite Dossier de Arquitectura"
                />

            </div>
        )
    }
}
export default SubcatesCategory;